import { MultiCodeBlock } from 'gatsby-theme-apollo-docs';
import MutationOptions from "../../../gatsby-source-git/2.6/docs/shared/mutation-options.mdx";
import MutationResult from "../../../gatsby-source-git/2.6/docs/shared/mutation-result.mdx";
import * as React from 'react';
export default {
  MultiCodeBlock,
  MutationOptions,
  MutationResult,
  React
};